import { render, staticRenderFns } from "./ViewUserAccess.vue?vue&type=template&id=91de6b7c&scoped=true"
import script from "./ViewUserAccess.vue?vue&type=script&lang=js"
export * from "./ViewUserAccess.vue?vue&type=script&lang=js"
import style0 from "./ViewUserAccess.vue?vue&type=style&index=0&id=91de6b7c&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "91de6b7c",
  null
  
)

export default component.exports